import { InfoTooltip } from '../common/InfoTooltip';
import { MoneyDisplay } from '../common/MoneyDisplay';
import { LiquidityHorizonDonut } from './LiquidityHorizonDonut';
import pt from '../../locales/pt';
import { cn } from '../../utils/cn';

/**
 * `.pen` → cartão "resumo · ativos": total + barra parado/investido +
 * (dentro do mesmo cartão, sem cartão próprio) o bloco de liquidez por
 * horizonte — mesma família visual do `DashboardLiquidityCard`, mas
 * embutido aqui em vez de um cartão à parte.
 */
export function AccountsSummaryCard({
  totalEur = 0,
  liquidEur = 0,
  investedEur = 0,
  liquidPct = 0,
  investedPct = 0,
  horizonBuckets = [],
  className,
}) {
  const showBreakdown = totalEur > 0;
  const showHorizons = horizonBuckets.length > 0;

  return (
    <section
      className={cn(
        'flex flex-col gap-space-4 rounded-ds-xl border border-border bg-card p-space-5 shadow-[0_6px_16px] shadow-glass-shadow/[0.12] dark:shadow-glass-shadow/[0.45]',
        className,
      )}
    >
      <div className="flex flex-col gap-space-1">
        <div className="flex items-center gap-1.5 type-section text-muted-foreground">
          {pt.accounts.summaryCard.totalLabel}
          <InfoTooltip text={pt.accounts.summaryCard.totalTooltip} className="h-3.5 w-3.5" />
        </div>
        <MoneyDisplay
          value={totalEur}
          className="font-display text-type-display-kpi font-bold tracking-tight text-foreground"
        />
      </div>

      {showBreakdown ? (
        <div className="flex flex-col gap-space-2-5">
          <div className="flex h-2 overflow-hidden rounded-ds-full">
            {liquidPct > 0 && (
              <span className="bg-sage-500" style={{ width: `${liquidPct}%` }} aria-hidden />
            )}
            {investedPct > 0 && (
              <span className="bg-capital-invested" style={{ width: `${investedPct}%` }} aria-hidden />
            )}
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1.5">
              <span className="h-2 w-2 shrink-0 rounded-full bg-sage-500" aria-hidden />
              <span className="type-label font-normal text-muted-foreground">
                {pt.accounts.liquidity.available}
              </span>
              <MoneyDisplay
                value={liquidEur}
                className="font-display type-label font-bold text-foreground"
              />
            </div>
            <div className="flex items-center gap-1.5">
              <span className="h-2 w-2 shrink-0 rounded-full bg-capital-invested" aria-hidden />
              <span className="type-label font-normal text-muted-foreground">
                {pt.accounts.liquidity.invested}
              </span>
              <MoneyDisplay
                value={investedEur}
                className="font-display type-label font-bold text-foreground"
              />
            </div>
          </div>
        </div>
      ) : null}

      {/* `.pen` `resumo · ativos` (`uAd7w`): sep + o donut como cartão aninhado,
          com o seu próprio head — sem cabeçalho duplicado aqui. */}
      {showHorizons ? (
        <>
          <div className="h-px bg-border" aria-hidden />
          <LiquidityHorizonDonut horizonBuckets={horizonBuckets} orientation="row" />
        </>
      ) : null}
    </section>
  );
}
